import { kebabCase } from 'lodash';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { ReminderFrequency } from '../../types/api/graphql';
import { ReminderMessageType } from './enums';

export const useReminderMessageTypeValues = () => {
  const intl = useIntl();

  const data = useMemo(
    () =>
      Object.values(ReminderMessageType).map(option => ({
        key: option,
        title: intl.formatMessage({
          id: `common.reminder-message-type.${kebabCase(option)}`,
        }),
      })),
    [intl]
  );

  return {
    data,
    loading: false,
  };
};

export const useReminderFrequencyValues = () => {
  const intl = useIntl();

  const data = useMemo(
    () =>
      [
        ReminderFrequency.TwoWeeks,
        ReminderFrequency.SixWeeks,
        ReminderFrequency.Monthly,
        ReminderFrequency.ThreeMonths,
        ReminderFrequency.SixMonths,
        ReminderFrequency.Yearly,
      ].map(option => ({
        key: option,
        title: intl.formatMessage({
          id: `common.reminder-frequency.${kebabCase(option)}`,
        }),
      })),
    [intl]
  );

  return {
    data,
    loading: false,
  };
};
